/**
 * Cross-component "is the maintenance dialog on screen?" signal.
 *
 * The marker attribute lives on the maintenance dialog's root element, which
 * is server-rendered, so it is present in the HTML **before any JS runs**.
 * That is why this can be a synchronous DOM read instead of a store: there is
 * no effect-ordering race to lose. Every other overlay in the app reveals
 * itself from a `useEffect`, and effects run after the document is parsed, so
 * by the time any of them ask, the answer is already correct.
 *
 * CONTRACT: only call this from inside an effect, or after a condition that is
 * already `false` during hydration. Calling it in a render path that also ran
 * on the server would produce a hydration mismatch, since the server has no
 * `document`.
 *
 * Kept import-free on purpose — it ships in the shared client bundle on every
 * page, maintenance or not.
 */
export const MAINTENANCE_ATTR = "data-sticko-maintenance";

export function isMaintenanceActive(): boolean {
  if (typeof document === "undefined") return false;
  return document.querySelector(`[${MAINTENANCE_ATTR}]`) !== null;
}
